// Catalog of financial calendar event themes and notification triggers.
//
// Themes are hardcoded on purpose. Unlike the email subscription categories,
// which come from the public GET /subscription/categories, the only endpoints
// that expose a financial calendar `theme` are
// GET /financial-calendar/listing/{listingId} and .../upcoming, and both
// require a bearer token. This page is served anonymously from a static
// bucket, so it has no way to authenticate. If a public themes endpoint is
// added later, replace EVENT_THEMES with a hook shaped like UseGetCategories.
//
// `value` is what gets sent to the API. The API matches themes against the
// calendar ignoring casing and surrounding whitespace, and echoes them back
// lower cased, which is why `key` is the lower cased form used for comparison.
//
// Themes are always sent in English, including when the subscription language
// is ARABIC. Only the labels shown to the reader are translated, and those
// live in translations.json under newsEvent.themes.
export const EVENT_THEMES = [
  { key: "financial statement", value: "Financial Statement" },
  { key: "general assembly meeting", value: "General Assembly Meeting" },
  { key: "board of directors", value: "Board of Directors" },
  { key: "conference call", value: "Conference Call" },
  { key: "qse events", value: "QSE Events" },
  { key: "dividends", value: "Dividends" },
  { key: "bonus shares", value: "Bonus Shares" },
  { key: "ipo/ subscription", value: "IPO/ Subscription" },
];

// Moments at which to notify about a matching event, in chronological order.
export const EVENT_TRIGGERS = [
  "WHEN_ANNOUNCED",
  "ONE_MONTH_BEFORE",
  "ONE_WEEK_BEFORE",
  "ONE_DAY_BEFORE",
  "SAME_DAY",
];

export const normalizeTheme = (theme) => `${theme}`.trim().toLowerCase();

export const themeValueOf = (key) => {
  const item = EVENT_THEMES.find((t) => t.key === key);
  return item ? item.value : key;
};
